<template>
    <div class="SX">
       <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">首页></span>
        <span @click="GoSiXiang">巡视巡察></span>
          <span @click="GoJT">集团动态></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
    <div class="zhengwen">
      <h1>“三个贯穿始终”推进巡察工作取得实效</h1>
      <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
      <div class="xh"></div>
      <div class="second">
        <p>为了进一步强化党内监督，推进全面从严治党向基层延伸，崇信县坚持以“三个贯穿始终”为抓手，高起点谋划，高标准定位，高效能推进，5月份部署开展了第五轮（2020年）巡察，采取常规巡察镶嵌脱贫攻坚专项巡察“回头看”的方式，对3个县直部门及22个行政村进行了巡察，共发现立行立改问题9条，一般性问题189条，问题线索5条。</p>

        <strong><p>　　一是坚持把政治巡察定位贯穿始终。</p></strong>

        <p>始终坚持以习近平新时代中特色社会主义思想为指导，深入贯彻落实习近平总书记关于巡视巡察工作重要论述和“发现问题、形成震慑，推动改革、促进发展”巡视工作16字方针，聚焦党中央关于统筹疫情防控和经济社会发展、做好“六稳”工作、落实“六保”任务的落实落地，把“两个维护”作为对村（社区）党组织巡察监督的根本政治任务，紧紧围绕如期实现脱贫攻坚目标、全面建成小康社会、实施“乡村振兴”战略，坚守政治巡察定位，紧扣“三个聚焦”监督重点，坚持以“四个紧盯”“两不愁三保障”“两个清零”等脱贫攻坚任务落实情况开展巡察。 </p>

        <p> </p>
          <strong><p>二是坚持把创新工作方法贯穿始终。　 </p></strong>

        <p>工作安排上，县委对第五轮巡察方案反复讨论修改，在全面承接中央和省市巡视巡察监督重点的基础上，灵活应用多种方式，创新提出了常规巡察镶嵌脱贫攻坚专项巡察镶嵌巡察“回头看”的方式。时间从3个月压缩至1个半月，突出“短平快”；在巡察内容、工作进度上，保持与省委巡视、市委巡察同步对接、同步推进；在巡察程序上，作了简化优化。常规巡察的3个县直部门只联合召开了一次动员会，在巡察期间只同有关领导干部进行了一次谈话，调取了一次有关材料，县委巡察工作领导小组在巡察中期听取了一次专题汇报；专项巡察采取“四不两直”方式，直接进村入户工作，没有召开反馈会，巡察结束后以书面形式进行问题和意见反馈。</p>
 <strong><p>三是坚持把推动解决具体问题贯穿始终。　 </p></strong>
        <p>始终把推动解决群众反映强烈的急难愁盼类问题作为巡察工作的鲜明特点，把边巡边改、立行立改贯穿巡察全过程，立足“早发现、快处置”，对一些进驻期间发现的能立即解决的群众诉求类问题，及时通报督促被巡察单位党组织马上“改”、立刻“行”；对一些普遍存在的共性问题，及时汇报领导小组，督促各相关单位组织开展专项督查检查，限期整改落实。巡察期间发现立行立改问题9条，已全部反馈被巡察单位和相关职能单位，截止巡察结束前已全部完成整改。
 </p>
      </div>
    </div>
      
    
    </div>


    </div>
</template>
<script>
export default {
    methods: {
         GoRisk() {
      this.$router.push("/HOME");
    },
   GoSiXiang() {
      this.$router.push("/MakeInspectionTour");
    },
   GoJT() {
      this.$router.push("/MakeInspectionTour/JiTuan");
    },
    },
    
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.si{
   margin: 0 16px;
 }
</style>